import Participant from "../../participant";
import { CMSContentType } from "../CMSType";
import { BaseListContentParams, BaseListContent } from "./list.abstract.content";
import { List } from "immutable";
import { AContentDTO } from "../base.content";

/*
export interface ITwoColumnContentRaw {
  rightLabel: string;
  leftLabel: string;
  items: Array<ITwoColumnContentRowRaw>;
}

export interface ITwoColumnContentRowRaw {
  leftCell: ITwoColumnContentCellRaw;
  rightCell: ITwoColumnContentCellRaw;
}

export interface ITwoColumnContentCellRaw {
  primaryText: string;
  avatar: string;
  record_id: string;
}
*/

export interface TwoColumnContentDTO extends AContentDTO {
  rightLabel: string;
  leftLabel: string;
  items: TwoColumnContentRowDTO[];
}

export interface TwoColumnContentRowDTO extends AContentDTO {
  leftCell: TwoColumnContentCellDTO;
  rightCell: TwoColumnContentCellDTO;
}

export interface TwoColumnContentCellDTO {
  primaryText: string;
}

export interface TwoColumnContentClubCellDTO extends TwoColumnContentCellDTO {
  avatar: string;
  record_id: string;
}

export class TwoColumnContentCell {
  public avatar: string;

  constructor(public primaryText: string = '') {
    this.primaryText = primaryText;
  }

  setPrimaryText(value: string): TwoColumnContentCell {
    this.primaryText = value;
    return this;
  }
}

export class TwoColumnContentClubCell extends TwoColumnContentCell {
  public record_id: string = 'free';

  constructor(primaryText: string = 'Free agent', image?: string, record_id?: string) {
    super(primaryText);
    this.avatar = image;
    this.record_id = record_id || 'free';
  }

  update(participant: Participant): TwoColumnContentClubCell {
    if (participant !== null) {
      this.primaryText = participant.name;
      this.record_id = participant.id;
      this.avatar = participant.logo.thumbnail;
    } else {
      this.primaryText = 'Free agent';
      this.record_id = 'free';
      this.avatar = undefined;
    }
    return this;
  }
}

export abstract class TwoColumnContentItemTemplate<LeftType extends TwoColumnContentCell, RightType extends TwoColumnContentCell> {
  public leftCell: LeftType;
  public rightCell: RightType;

  setLeftCell(cell: LeftType) {
    this.leftCell = cell;
    return this;
  }

  setRightCell(cell: RightType) {
    this.rightCell = cell;
    return this;
  }

  public toJSON() {
    return {
      leftCell: this.leftCell,
      rightCell: this.rightCell
    };
  }
}

export class TwoColumnContentItem extends TwoColumnContentItemTemplate<TwoColumnContentCell, TwoColumnContentCell> {
  constructor() {
    super();
    this.leftCell = new TwoColumnContentCell();
    this.rightCell = new TwoColumnContentCell();
  }
}

export interface ATwoColumnContentParams<T> extends BaseListContentParams<T> {
  leftLabel: string;
  rightLabel: string;
}

export abstract class ATwoColumnContent<T> extends BaseListContent<T> {
  readonly leftLabel: string;
  readonly rightLabel: string;

  constructor(type: CMSContentType, data: ATwoColumnContentParams<T>) {
    super(type, data);
    // this.leftLabel = data.leftLabel;
    this.leftLabel = "Player";
    // this.rightLabel = data.rightLabel;
    this.rightLabel = "Club";
  }

  get children(): List<T>{
    return this.items;
  }

  setLeftLabel(label: string): this {
    return this._merge({leftLabel: label});
  }

  setRightLabel(label: string): this {
    return this._merge({rightLabel: label});
  }

  abstract addRow(row): this;

  public toJSON() {
    return Object.assign(super.toJSON(), {
      leftLabel: this.leftLabel,
      rightLabel: this.rightLabel
    })
  }
}

export interface TwoColumnContentParams extends ATwoColumnContentParams<TwoColumnContentItem> {

}

export class TwoColumnContent extends ATwoColumnContent<TwoColumnContentItem> {
  constructor(data: TwoColumnContentParams) {
    super(CMSContentType.twoColumns, data);
  }

  addRow(): this {
    return this.push(new TwoColumnContentItem());
  }
}

export default TwoColumnContent;



// WEBPACK FOOTER //
// ./src/api/club-cms/content/two-column.content.ts